import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AjoutProjetComponent} from "../project-parametre/ajout-projet/ajout-projet.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AjoutIntegrationComponent} from "./ajout-integration/ajout-integration.component";

@Component({
  selector: 'app-integration-parametre',
  templateUrl: './integration-parametre.component.html',
  styleUrls: ['./integration-parametre.component.scss']
})
export class IntegrationParametreComponent implements OnInit {

  @ViewChild('ajoutIntegration') ajoutIntegrationComponent!: AjoutIntegrationComponent;


  constructor(private modalService: NgbModal) {}



  ngOnInit(): void {
  }

  openAjoutModal() {
    this.ajoutIntegrationComponent.openModal();
  }

}
